var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(0.963373,0,0,1,-14.4506,-15)"},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.006 17.3093C19.9771 15.9985 19.0397 15 17.5174 15C15.9952 15 15 15.9985 15 17.3093C15 18.5931 15.9658 19.6203 17.4597 19.6203H17.4881C19.0397 19.6203 20.006 18.5931 20.006 17.3093ZM19.7128 21.4451H15.2631V34.8148H19.7128V21.4451ZM30.6371 21.1312C33.5652 21.1312 35.7604 23.0425 35.7604 27.149L35.7602 34.8148H31.3107V27.662C31.3107 25.8654 30.6667 24.6394 29.0559 24.6394C27.8266 24.6394 27.0943 25.4659 26.7727 26.2642C26.6551 26.5503 26.6262 26.9489 26.6262 27.3484V34.8152H22.1759C22.1759 34.8152 22.2346 22.7 22.1759 21.4455H26.6262V23.3392C27.2168 22.4289 28.2745 21.1312 30.6371 21.1312Z","fill":"currentColor"})));
}

Linkedin.defaultProps = {"viewBox":"0 0 20 20","fill":"none","style":{"color":"#39424A"}};

module.exports = Linkedin;

Linkedin.default = Linkedin;
